import { lazy, Suspense } from "react";
import SubHeader from "./SubHeader";
const ContactAddress = lazy(() => import("./ContactAddress"));
const ContactForm = lazy(() => import("./ContactForm"));

export default function Contact() {
  return (
    <>
      <SubHeader />
      <Suspense fallback={null}>
        <ContactForm />
        <ContactAddress />
      </Suspense>
    </>
  );
}
